import React from 'react';
import PropTypes from 'prop-types';
import { useThemeTokens } from '../ThemeProvider';
import { getTokensPropType, variantProp } from '../utils/props';
import Spinner from './Spinner';

/**
 * `ActivityIndicator` renders a visual loading state.
 * It does not handle positioning or layout of that visual loader.
 */
import { jsx as _jsx } from "react/jsx-runtime";
const ActivityIndicator = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    variant,
    tokens,
    label,
    isStatic = false
  } = _ref;
  const {
    size,
    color,
    thickness
  } = useThemeTokens('ActivityIndicator', tokens, variant);
  return /*#__PURE__*/_jsx(Spinner, {
    ref: ref,
    size: size,
    color: color,
    thickness: thickness,
    label: label,
    isStatic: isStatic
  });
});
ActivityIndicator.displayName = 'ActivityIndicator';
ActivityIndicator.propTypes = {
  variant: variantProp.propType,
  tokens: getTokensPropType('ActivityIndicator'),
  /**
   * A visually hidden accessible label describing the action taking place
   */
  label: PropTypes.string.isRequired,
  /**
   * If true, it should render a static spinner
   */
  isStatic: PropTypes.bool
};
export default ActivityIndicator;